import { IDefaultLayoutProps } from '@/types/.component.ts';
import { useLocation } from 'react-router';
import { useLayoutEffect } from 'react';
import classNames from 'classnames';
import StickyBox from 'react-sticky-box';
import { SafeArea } from 'antd-mobile';

export default function DefaultLayout(props: IDefaultLayoutProps) {
    const { children, className, style, header, footer, grabberClassname, ...rest } = props;

    const location = useLocation();
    useLayoutEffect(() => {
        document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    }, [location.pathname]);

    return (
        <div className={classNames('ux-default-layout', className)} style={style} {...rest}>
            {header ? (
                <StickyBox offsetTop={0}>
                    <div className="ux-default-layout__head">{header}</div>
                </StickyBox>
            ) : null}

            <div className="ux-default-layout__body">
                <div className="w-full">{children}</div>
            </div>
            <StickyBox offsetBottom={0} bottom>
                <div className="ux-default-layout__foot">
                    {footer}
                    <SafeArea position="bottom" className={grabberClassname} />
                </div>
            </StickyBox>
        </div>
    );
}
